$(document).ready(function(){
  customQuantitySelector();
});

function customQuantitySelector ()
{
  $('.inc-button').click(function(){
    var currentValue = parseInt($('input#quantity').val());
    console.log(currentValue, 'aaaaaaaaaaaaa');
    var updatedValue = currentValue + 1;
    $('input#quantity').val(updatedValue);
  })

  $('.dec-button').click(function(){
    var currentValue = parseInt($('input#quantity').val());
    console.log(currentValue, 'aaaaaaaaaaaaa');
    if (currentValue > 1)
    {
      var updatedValue = currentValue - 1;
      $('input#quantity').val(updatedValue);
    }
  })

}
